import React, { useEffect } from "react";
import * as Scrivito from "scrivito";
import { getHomepage, isConfiguratorNavVisible, getPageObj } from "utils";
import { useAuthStore } from "stores/authStore";
import { useUrqlContext } from "providers";
import { NavStandard, NavConfigurator } from "./Navigation/index";

export const Navigation = Scrivito.connect(({ device }) => {
  const { setUrqlClient } = useAuthStore.use.actions();
  const { client } = useUrqlContext();
  const isAuthenticated = useAuthStore.use.isAuthenticated();

  useEffect(() => {
    setUrqlClient(client);

    if (!isAuthenticated) {
      Scrivito.navigateTo(() => getPageObj("LoginPage"));
    }
  }, [client, setUrqlClient, isAuthenticated]);

  const homepage = getHomepage();
  if (!homepage) {
    return null;
  }

  const currentPage = Scrivito.currentPage();

  return (
    <>
      {isConfiguratorNavVisible(currentPage) ? (
        <NavConfigurator homepage={homepage} device={device} />
      ) : (
        <NavStandard homepage={homepage} />
      )}
    </>
  );
});
